import { Tag } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

interface CardTagProps {
    isVisible: boolean
}

export const CardTag = ({ isVisible }: CardTagProps) => {
    const { t } = useTranslation()

    if (!isVisible) {
        return null
    }
    return <Tag className="ml-10 ant-tag-blue">{t("label:cards.card")}</Tag>
}
